export default __webpack_public_path__ + "static/font-86dc4e453105852edfbb5fab8981ecf8.woff2";